<template>
    <div class="print-pay-fee-xiangyun-container">
        <!-- 第一份收据（存根联）：收费单位留存归档 -->
        <div class="receipt-item">
            <div class="text-center">
                <div style="color:#000;font-size:36px">
                    {{ printPayFeeInfo.communityName }} {{ printPayFeeInfo.apply == 'Y' ? $t('printPayFeeXiangyun.applyForm') : $t('printPayFeeXiangyun.receiptForm') }}
                </div>
            </div>
            <div style="color:#000;font-size:20px;text-align:right;margin-bottom:10px;">
                <span>{{ $t('printPayFeeXiangyun.receiptNum') }}：{{ printPayFeeInfo.receiptNum }}</span>
            </div>
            <el-row style="color:#000;font-size:20px;margin-bottom:10px;">
                <el-col :span="12" class="text-left">
                    <span>{{ $t('printPayFeeXiangyun.owner') }}：{{ printPayFeeInfo.payObjName }}</span>
                </el-col>
                <el-col :span="12" style="text-align:right;">
                    <span>{{ $t('printPayFeeXiangyun.payTime') }}：{{ printPayFeeInfo.feeTime }}</span>
                </el-col>
            </el-row>

            <table class="table vc-table-border" style="color:#000;font-size:20px">
                <thead>
                    <tr>
                        <th scope="col" class="text-center" width="80px">
                            {{ $t('printPayFeeXiangyun.serialNumber') }}
                        </th>
                        <th scope="col" class="text-center">
                            {{ $t('printPayFeeXiangyun.feeItem') }}
                        </th>
                        <th scope="col" class="text-center">
                            {{ $t('printPayFeeXiangyun.houseCar') }}
                        </th>
                        <th scope="col" class="text-center">
                            {{ $t('printPayFeeXiangyun.feeRange') }}
                        </th>
                        <th scope="col" class="text-center">
                            {{ $t('printPayFeeXiangyun.cycle') }}
                        </th>
                        <th scope="col" class="text-center">
                            {{ $t('printPayFeeXiangyun.unitPriceFixed') }}
                        </th>
                        <th scope="col" class="text-center">
                            {{ $t('printPayFeeXiangyun.areaUsage') }}
                        </th>
                        <th scope="col" class="text-center">
                            {{ $t('printPayFeeXiangyun.paymentMethod') }}
                        </th>
                        <th scope="col" class="text-center">
                            {{ $t('printPayFeeXiangyun.amount') }}
                        </th>
                        <th scope="col" class="text-center">
                            {{ $t('printPayFeeXiangyun.discountAmount') }}
                        </th>
                        <th scope="col" class="text-center">
                            {{ $t('printPayFeeXiangyun.remark') }}
                        </th>
                    </tr>
                </thead>
                <tbody class="vc-table-border" style="color:#000;font-size:20px">
                    <!-- 费用明细列表：循环渲染每笔缴费记录，key确保唯一性 -->
                    <tr v-for="(item, index) in printPayFeeInfo.fees" :key="index" class="vc-table-border">
                        <th scope="row" class="text-center">{{ index + 1 }}</th>
                        <td class="text-center">{{ item.feeName }}</td>
                        <td class="text-center">{{ item.objName }}</td>
                        <!-- 区分有表底度数（如水、电）和无表底度数的费用区间显示 -->
                        <td class="text-center" v-if="item.preDegrees">
                            {{ dateFormat(item.startTime) }}{{ $t('printPayFeeXiangyun.to') }}{{ dateFormat(item.endTime) }}<br />
                            {{ item.preDegrees }} {{ $t('printPayFeeXiangyun.to') }} {{ item.curDegrees }}
                        </td>
                        <td class="text-center" v-else-if="item.feeTypeCd == '888800010006'">
                            {{ $t('printPayFeeXiangyun.none') }}
                        </td>
                        <td class="text-center" v-else>
                            {{ dateFormat(item.startTime) }}{{ $t('printPayFeeXiangyun.to') }}{{ dateFormat(item.endTime) }}
                        </td>
                        <td class="text-center">{{ item.cycle }}</td>
                        <td class="text-center">{{ item.squarePrice }}</td>
                        <td class="text-center">{{ item.area }}</td>
                        <td class="text-center">{{ item.primeRate }}</td>
                        <td class="text-center">{{ item.amount }}</td>
                        <td class="text-center">{{ item.discountPrice }}</td>
                        <td class="text-center" width="200px">
                            {{ item.remark || '' }}
                        </td>
                    </tr>
                    <!-- 金额汇总行：显示大写金额和小写总金额，跨列合并排版 -->
                    <tr>
                        <td colspan="3" class="text-center">
                            {{ $t('printPayFeeXiangyun.capitalRMB') }}（元）
                        </td>
                        <td colspan="4" class="text-center">
                            {{ changeNumMoneyToChinese(printPayFeeInfo.amount) }}
                        </td>
                        <td colspan="4" class="text-center">{{ printPayFeeInfo.amount }}</td>
                    </tr>
                    <!-- 附加内容行：显示系统配置的说明文本和二维码，有内容时才显示，优化居中+二维码尺寸 -->
                    <tr height="120px" v-if="printPayFeeInfo.content || printPayFeeInfo.qrImg">
                        <td colspan="7" class="text-center" style="vertical-align: middle;">
                            <div style="max-width: 600px; margin: 0 auto; text-align: center;" v-html="printPayFeeInfo.content"></div>
                        </td>
                        <td colspan="4" class="text-center" style="vertical-align: middle;">
                            <img v-if="printPayFeeInfo.qrImg" :src="printPayFeeInfo.qrImg" width="150px" height="150px" style="display: inline-block;">
                        </td>
                    </tr>
                </tbody>
            </table>

            <!-- 签字栏：负责人、操作员、财务、客户确认签字位置 -->
            <el-row style="color:#000;font-size:20px;margin-top:20px;">
                <el-col :span="20">
                    <el-row>
                        <el-col :span="6">{{ $t('printPayFeeXiangyun.departmentHead') }}：</el-col>
                        <el-col :span="6">{{ $t('printPayFeeXiangyun.operator') }}：</el-col>
                        <el-col :span="6">{{ $t('printPayFeeXiangyun.financeReceipt') }}：</el-col>
                        <el-col :span="6">{{ $t('printPayFeeXiangyun.customerConfirm') }}：</el-col>
                    </el-row>
                </el-col>
            </el-row>
        </div>

        <!-- 分割线：两份收据之间留白，打印时便于区分和裁剪 -->
        <div class="split-line"></div>

        <!-- 第二份收据（客户联）：缴费人留存作为缴费凭证 -->
        <div class="receipt-item">
            <div class="text-center">
                <div style="color:#000;font-size:36px">
                    {{ printPayFeeInfo.communityName }} {{ printPayFeeInfo.apply == 'Y' ? $t('printPayFeeXiangyun.applyForm') : $t('printPayFeeXiangyun.receiptForm') }}
                </div>
            </div>
            <div style="color:#000;font-size:20px;text-align:right;margin-bottom:10px;">
                <span>{{ $t('printPayFeeXiangyun.receiptNum') }}：{{ printPayFeeInfo.receiptNum }}</span>
            </div>
            <el-row style="color:#000;font-size:20px;margin-bottom:10px;">
                <el-col :span="12" class="text-left">
                    <span>{{ $t('printPayFeeXiangyun.owner') }}：{{ printPayFeeInfo.payObjName }}</span>
                </el-col>
                <el-col :span="12" style="text-align:right;">
                    <span>{{ $t('printPayFeeXiangyun.payTime') }}：{{ printPayFeeInfo.feeTime }}</span>
                </el-col>
            </el-row>

            <table class="table vc-table-border" style="color:#000;font-size:20px">
                <thead>
                    <tr>
                        <th scope="col" class="text-center" width="80px">
                            {{ $t('printPayFeeXiangyun.serialNumber') }}
                        </th>
                        <th scope="col" class="text-center">
                            {{ $t('printPayFeeXiangyun.feeItem') }}
                        </th>
                        <th scope="col" class="text-center">
                            {{ $t('printPayFeeXiangyun.houseCar') }}
                        </th>
                        <th scope="col" class="text-center">
                            {{ $t('printPayFeeXiangyun.feeRange') }}
                        </th>
                        <th scope="col" class="text-center">
                            {{ $t('printPayFeeXiangyun.cycle') }}
                        </th>
                        <th scope="col" class="text-center">
                            {{ $t('printPayFeeXiangyun.unitPriceFixed') }}
                        </th>
                        <th scope="col" class="text-center">
                            {{ $t('printPayFeeXiangyun.areaUsage') }}
                        </th>
                        <th scope="col" class="text-center">
                            {{ $t('printPayFeeXiangyun.paymentMethod') }}
                        </th>
                        <th scope="col" class="text-center">
                            {{ $t('printPayFeeXiangyun.amount') }}
                        </th>
                        <th scope="col" class="text-center">
                            {{ $t('printPayFeeXiangyun.discountAmount') }}
                        </th>
                        <th scope="col" class="text-center">
                            {{ $t('printPayFeeXiangyun.remark') }}
                        </th>
                    </tr>
                </thead>
                <tbody class="vc-table-border" style="color:#000;font-size:20px">
                    <!-- 费用明细列表：与第一份一致，key加two避免重复警告 -->
                    <tr v-for="(item, index) in printPayFeeInfo.fees" :key="index+'two'" class="vc-table-border">
                        <th scope="row" class="text-center">{{ index + 1 }}</th>
                        <td class="text-center">{{ item.feeName }}</td>
                        <td class="text-center">{{ item.objName }}</td>
                        <!-- 区分有表底度数（如水、电）和无表底度数的费用区间显示 -->
                        <td class="text-center" v-if="item.preDegrees">
                            {{ dateFormat(item.startTime) }}{{ $t('printPayFeeXiangyun.to') }}{{ dateFormat(item.endTime) }}<br />
                            {{ item.preDegrees }} {{ $t('printPayFeeXiangyun.to') }} {{ item.curDegrees }}
                        </td>
                        <td class="text-center" v-else-if="item.feeTypeCd == '888800010006'">
                            {{ $t('printPayFeeXiangyun.none') }}
                        </td>
                        <td class="text-center" v-else>
                            {{ dateFormat(item.startTime) }}{{ $t('printPayFeeXiangyun.to') }}{{ dateFormat(item.endTime) }}
                        </td>
                        <td class="text-center">{{ item.cycle }}</td>
                        <td class="text-center">{{ item.squarePrice }}</td>
                        <td class="text-center">{{ item.area }}</td>
                        <td class="text-center">{{ item.primeRate }}</td>
                        <td class="text-center">{{ item.amount }}</td>
                        <td class="text-center">{{ item.discountPrice }}</td>
                        <td class="text-center" width="200px">
                            {{ item.remark || '' }}
                        </td>
                    </tr>
                    <!-- 金额汇总行：显示大写金额和小写总金额，跨列合并排版 -->
                    <tr>
                        <td colspan="3" class="text-center">
                            {{ $t('printPayFeeXiangyun.capitalRMB') }}（元）
                        </td>
                        <td colspan="4" class="text-center">
                            {{ changeNumMoneyToChinese(printPayFeeInfo.amount) }}
                        </td>
                        <td colspan="4" class="text-center">{{ printPayFeeInfo.amount }}</td>
                    </tr>
                    <!-- 附加内容行：显示系统配置的说明文本和二维码，有内容时才显示，优化居中+二维码尺寸 -->
                    <tr height="120px" v-if="printPayFeeInfo.content || printPayFeeInfo.qrImg">
                        <td colspan="7" class="text-center" style="vertical-align: middle;">
                            <div style="max-width: 600px; margin: 0 auto; text-align: center;" v-html="printPayFeeInfo.content"></div>
                        </td>
                        <td colspan="4" class="text-center" style="vertical-align: middle;">
                            <img v-if="printPayFeeInfo.qrImg" :src="printPayFeeInfo.qrImg" width="150px" height="150px" style="display: inline-block;">
                        </td>
                    </tr>
                </tbody>
            </table>

            <!-- 签字栏：负责人、操作员、财务、客户确认签字位置 -->
            <el-row style="color:#000;font-size:20px;margin-top:20px;">
                <el-col :span="20">
                    <el-row>
                        <el-col :span="6">{{ $t('printPayFeeXiangyun.departmentHead') }}：</el-col>
                        <el-col :span="6">{{ $t('printPayFeeXiangyun.operator') }}：</el-col>
                        <el-col :span="6">{{ $t('printPayFeeXiangyun.financeReceipt') }}：</el-col>
                        <el-col :span="6">{{ $t('printPayFeeXiangyun.customerConfirm') }}：</el-col>
                    </el-row>
                </el-col>
            </el-row>
        </div>

        <!-- 操作按钮区：打印和关闭按钮，仅显示一份，打印时自动隐藏 -->
        <el-row style="color:#000;font-size:20px;margin-top:30px;" id="print-btn">
            <el-col :span="24" style="text-align:right;">
                <el-button type="primary" class="float-right" @click="handlePrint">
                    <i class="fa fa-check"></i>&nbsp;{{ $t('common.print') }}
                </el-button>
                <el-button type="warning" class="float-right" style="margin-right:20px;" @click="handleClose">
                    {{ $t('common.cancel') }}
                </el-button>
            </el-col>
        </el-row>
    </div>
</template>

<script>
// 导入所需API和工具函数：社区信息、缴费收据相关接口、日期格式化、金额转大写
import { getCommunityId, getCommunityName } from '@/api/community/communityApi'
import { queryFeeReceipt, queryFeeReceiptDetail, queryFeePrintSpec } from '@/api/fee/printPayFeeApi'
import { dateFormat } from '@/utils/dateUtil'
import { changeNumMoneyToChinese } from '@/utils/moneyUtil'

export default {
    name: 'PrintPayFeeXiangyun',
    data() {
        return {
            // 打印收据所需核心数据：社区名称、收据编号、费用明细、总金额等
            printPayFeeInfo: {
                communityName: '',
                receiptId: '',
                receiptIds: '',
                detailIds: '',
                roomName: '',
                amount: 0.00,
                fees: [],
                feeTime: '',
                wechatName: '',
                content: '',
                qrImg: '',
                payObjName: '',
                feeReceipt: [],
                apply: 'N', // 是否为申请表（Y=是，N=收据）
                receiptNum: '', // 收据编号
                merge: '' // 是否合并费用
            },
            printFlag: '0', // 打印状态标识
            communityId: '' // 社区ID，用于接口请求
        }
    },
    created() {
        // 组件创建时初始化：获取社区ID，加载收据数据
        this.communityId = getCommunityId()
        this.initData()
    },
    methods: {
        // 初始化数据：获取路由参数，赋值给打印数据对象，加载收据和打印配置
        initData() {
            this.printPayFeeInfo.receiptId = this.$route.query.receiptId
            this.printPayFeeInfo.receiptIds = this.$route.query.receiptIds
            this.printPayFeeInfo.detailIds = this.$route.query.detailIds
            this.printPayFeeInfo.apply = this.$route.query.apply || 'N'
            this.printPayFeeInfo.merge = this.$route.query.merge
            this.printPayFeeInfo.communityName = getCommunityName()

            this.loadReceipt()
            this.loadPrintSpec()
        },
        // 加载收据主信息：通过接口获取收据汇总数据，计算总金额
        loadReceipt() {
            const params = {
                page: 1,
                row: 30,
                receiptId: this.printPayFeeInfo.receiptId,
                receiptIds: this.printPayFeeInfo.receiptIds,
                detailIds: this.printPayFeeInfo.detailIds,
                communityId: this.communityId
            }

            queryFeeReceipt(params).then(response => {
                const feeReceipt = response.data
                let amount = 0
                // 计算所有收据的总金额
                feeReceipt.forEach(item => {
                    amount += parseFloat(item.amount)
                })

                // 给打印数据对象赋值
                this.printPayFeeInfo.amount = amount.toFixed(2)
                this.printPayFeeInfo.roomName = feeReceipt[0].objName
                this.printPayFeeInfo.feeTime = feeReceipt[0].createTime
                this.printPayFeeInfo.payObjName = feeReceipt[0].payObjName
                this.printPayFeeInfo.feeReceipt = feeReceipt
                this.printPayFeeInfo.receiptNum = feeReceipt[0].receiptCode

                // 加载收据明细数据
                this.loadReceiptDetail()
            }).catch(error => {
                console.error('请求失败处理', error)
            })
        },
        // 加载收据明细信息：获取每笔费用的详细数据，关联收据信息
        loadReceiptDetail() {
            const params = {
                page: 1,
                row: 100,
                receiptId: this.printPayFeeInfo.receiptId,
                receiptIds: this.printPayFeeInfo.receiptIds,
                detailIds: this.printPayFeeInfo.detailIds,
                communityId: this.communityId,
                mergeFee: this.printPayFeeInfo.merge
            }

            queryFeeReceiptDetail(params).then(response => {
                const feeReceiptDetails = response.data
                // 收据编号拼接支付订单号，便于核对
                this.printPayFeeInfo.receiptNum = this.printPayFeeInfo.receiptNum + "(" + feeReceiptDetails[0].payOrderId + ")"

                // 给明细数据关联收据的房屋/车辆名称和费用类型
                feeReceiptDetails.forEach(item => {
                    this.printPayFeeInfo.feeReceipt.forEach(im => {
                        if (item.receiptId == im.receiptId) {
                            item.objName = im.objName
                            item.feeTypeCd = im.feeTypeCd
                        }
                    })
                })
                // 赋值明细数据，用于页面渲染
                this.printPayFeeInfo.fees = feeReceiptDetails
            }).catch(error => {
                console.error('请求失败处理', error)
            })
        },
        // 加载打印配置：获取系统配置的打印说明文本和二维码
        loadPrintSpec() {
            const params = {
                page: 1,
                row: 1,
                specCd: 2020,
                communityId: this.communityId
            }

            queryFeePrintSpec(params).then(response => {
                const data = response.data
                if (data.length > 0) {
                    this.printPayFeeInfo.content = data[0].content // 打印说明文本
                    this.printPayFeeInfo.qrImg = data[0].qrImg // 二维码图片地址
                    // 若配置了打印名称，替换社区名称
                    if (data[0].printName) {
                        this.printPayFeeInfo.communityName = data[0].printName
                    }
                }
            }).catch(error => {
                console.error('请求失败处理', error)
            })
        },
        // 日期格式化：调用工具函数，处理时间显示格式（空值返回空字符串）
        dateFormat(date) {
            if (!date) return ''
            return dateFormat(date)
        },
        // 金额转大写：直接使用导入的工具函数
        changeNumMoneyToChinese,
        // 打印操作：隐藏按钮，执行打印，打印后关闭窗口
        handlePrint() {
            this.printFlag = '1'
            document.getElementById("print-btn").style.display = "none"
            window.print()
            window.opener = null
            window.close()
        },
        // 关闭操作：关闭当前打印窗口
        handleClose() {
            window.opener = null
            window.close()
        }
    }
}
</script>

<style scoped>
/* 容器样式：设置内边距，确保收据内容不贴边 */
.print-pay-fee-xiangyun-container {
    padding: 20px;
}
/* 文本对齐样式：居中、右对齐、左对齐 */
.text-center {
    text-align: center;
}
.text-right {
    text-align: right;
}
.float-left {
    float: left;
}
.float-right {
    float: right;
}
/* 表格样式：宽度100%，合并边框，设置间距 */
.table {
    width: 100%;
    margin-bottom: 1rem;
    color: #212529;
    border-collapse: collapse;
}
/* 表格边框样式：黑色实线边框 */
.vc-table-border {
    border: 1px solid #000;
}
.vc-table-border th,
.vc-table-border td {
    border: 1px solid #000;
    padding: 8px;
    vertical-align: middle; /* 表格内容垂直居中，优化显示 */
}
/* 两份收据之间留白间距：便于打印后裁剪 */
.split-line {
    height: 40px;
    width: 100%;
}
/* 打印样式：隐藏按钮，强制每份收据单独一页 */
@media print {
    #print-btn {
        display: none !important;
    }
    .receipt-item {
        page-break-after: always;
    }
    /* 打印时确保二维码清晰，避免缩放模糊 */
    img {
        print-resolution: 300dpi;
        image-rendering: crisp-edges;
    }
}
</style>